import fetch from './http'

let baseURL = '',baseURL2 = '';
if (process.env.NODE_PM === 'prod') {
    baseURL = 'https://app.aigupiao.com';
    baseURL2 = 'https://apis.aigupiao.com'
} else if (process.env.NODE_PM === 'dev') {
    baseURL = 'https://appdev.aigupiao.com';
    baseURL2 = 'https://apisdev.aigupiao.com'
} else if (process.env.NODE_PM === 'beta') {
    baseURL = 'https://appbeta.aigupiao.com';
    baseURL2 = 'https://apisbeta.aigupiao.com'
}

// 老师 l_id=136
export const teacher = args => fetch({
    url: baseURL + '/api2/details.php?act=liver_detail',
    method: 'get',
    params: args.params,
    // headers: {
    //     'Authorization': 'Bearer ' + args.token
    // }
});

// 用户  u_id=790879
export const user = args => fetch({
    url: baseURL2 +  '/UserCenter/get_user_info',
    method: 'get',
    params: args.params,
    // headers: {
    //     'Authorization': 'Bearer ' + args.token
    // }
});